import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

export type CanonicalChartDatum = {
  label: string;
  value: number;
  color: string;
};

export function CanonicalDonutChart({
  data,
  ariaLabel,
}: {
  data: readonly CanonicalChartDatum[];
  ariaLabel: string;
}) {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  return (
    <figure className="ui-donut-chart" aria-label={ariaLabel}>
      <div className="ui-donut-chart__plot" aria-hidden="true">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data as CanonicalChartDatum[]}
              dataKey="value"
              nameKey="label"
              cx="50%"
              cy="50%"
              innerRadius="55%"
              outerRadius="92%"
              paddingAngle={1}
              stroke="#fff"
              strokeWidth={1}
            >
              {data.map((item) => <Cell key={item.label} fill={item.color} />)}
            </Pie>
            <Tooltip formatter={(value) => [`${String(value)} actas`, 'Cantidad']} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <figcaption>
        <ul className="ui-donut-chart__legend">
          {data.map((item) => (
            <li key={item.label}>
              <i style={{ background: item.color }} />
              <span>{item.label}</span>
              <strong>{item.value}{total ? ` (${Math.round(item.value * 100 / total)}%)` : ''}</strong>
            </li>
          ))}
        </ul>
      </figcaption>
    </figure>
  );
}
